//WE.Flow.Html.Contracts.Manifests.GroupMenuManifest
import { GroupMenuFunctionType } from "./GroupMenuFunctionType";

export class GroupMenuManifest {
    functionType: GroupMenuFunctionType = null;
    area: string = "";
    name: string = "";
    sortOrder: number = 0;
    alternateAreaName: string = "";
}
